import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import type { PickersCalendarHeaderProps } from '@mui/x-date-pickers/PickersCalendarHeader';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@src/shared/ui/Button';
import { Box } from '@src/shared/ui/layout';
import Typography from '@src/shared/ui/Typography';

export default function CalendarHeader(props: PickersCalendarHeaderProps) {
  const { currentMonth, onMonthChange } = props;
  const { t } = useTranslation();

  const prevYear = new Date(currentMonth);
  prevYear.setFullYear(prevYear.getFullYear() - 1);

  const nextYear = new Date(currentMonth);
  nextYear.setFullYear(nextYear.getFullYear() + 1);

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <IconButton
        size="small"
        onClick={() => onMonthChange(prevYear)}
        tooltipTitle={t('common.previous', 'Previous')}
      >
        <ChevronLeftIcon />
      </IconButton>
      <Typography variant="h4">{currentMonth.getFullYear()}</Typography>
      <IconButton
        size="small"
        onClick={() => onMonthChange(nextYear)}
        tooltipTitle={t('common.next', 'Next')}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
}
